import { SafeSuspense } from '@calendly/safe-suspense'
import { Loader } from '@calendly/ui/components/loader'
import { Modal } from '@calendly/ui/components/modal'
import { lazy, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { isOpenSelector } from '../selectors'
import { closeModal } from '../slice'

const loadChunk = async () => {
  const loaded = await import('./content')
  return { default: loaded.Content }
}

const Content = lazy(loadChunk)

export const OfferTimeSlotsModal = () => {
  const ref = useRef()
  const isOpen = useSelector(isOpenSelector)
  const dispatch = useDispatch()

  const onClose = () => {
    dispatch(closeModal())
  }

  return (
    <Modal ref={ref} isOpen={isOpen} onClose={onClose}>
      <div>
        <SafeSuspense fallback={<Loader />}>
          <Content modalRef={ref} />
        </SafeSuspense>
      </div>
    </Modal>
  )
}
